<div class="text-center d-flex flex-column justify-content-center align-items-center" style="font-size: 0.6rem;">
  <div class="links d-flex justify-content-center align-items-center">
    @for (link of links; track link; let first = $first; let last = $last) {
      <a
        [routerLink]="link.link"
        [ngClass]="{ 'text-right': first, 'text-left': last }">
        {{ 'footer.links.' + link.key | translate }}
      </a>
    }
  </div>
  <div class="copyriht">
    {{ 'footer.copyright' | translate:param}}
  </div>
</div>
